export default __webpack_public_path__ + "a49810da60c077cb7e0d97bb80a70260.svg";